'use strict';


import '../../scss/main/main.scss';

import { customizeHakuoshi } from "../component/customizeHakuoshi";
import { variantChangeActions } from '../product/variantchange';
import { productrecommendation } from '../product/productrecommendation';
import { sizeChart } from '../product/sizechart';
import { cartAnnouncement } from '../component/cart-announcement';
import { separateColor } from '../product/separateColor';
import { customproductbuilder } from '../component/customproductbuilder';
import { menuHamberger } from '../component/menuHamberger';
import { wishlistAddcart } from '../component/wishlist_addcart';
import { displayWarrantyButtons, prefillWarrantyInfo, showAlertMessage, externalWarrantyClickEvents, formatWarrantyPage } from '../warranty/warranty';
import { initQrCode } from "../apps/qrcode";
import { fillRepairDetails, displayRepairPopup, redirectEvent } from "../warranty/repairRequest";
import { initSettingsModals } from '../account/settings';
import { lineitemchange } from '../component/lineitem';
import { cartPageLineitemchange } from '../component/cartpage-lineitem';
import { cartGiftcard } from '../component/cart-giftcard';
import { customVideo } from '../component/custom-video';
// import { textInlineWithIcons } from '../component/textInlineWithIcons';
import { modifyDesignOfActiveAccount } from '../account/activateaccount';
import { swatchSlider } from '../component/swatch-slider';
import { cartNovelty } from '../component/cart-novelty';

import { productStickyBar } from '../product/productStickyBar';
import { productGallery } from '../product/productGallery';
import { accessoriesProduct } from '../product/accessoriesProduct';

// import '@fortawesome/fontawesome-free/js/fontawesome';
// import '@fortawesome/fontawesome-free/js/solid';
// import '@fortawesome/fontawesome-free/js/regular';

const currentUrl = document.URL;

if ( currentUrl.includes('/products') ) {
    customizeHakuoshi();
    variantChangeActions();
    productrecommendation();
    sizeChart();
    separateColor();
    productStickyBar();
    productGallery();
    accessoriesProduct();
} else if (currentUrl.includes('/cart')) {
    cartAnnouncement();
    cartPageLineitemchange();
    productrecommendation();
    cartGiftcard();
    cartNovelty();
} else if (currentUrl.includes('/pages/swym-wishlist')) {
    wishlistAddcart();
} else if (currentUrl.includes('/account/register')) {
    modifyDesignOfActiveAccount();
} else if (currentUrl.search(/\/account(?!.*\?[^?]*view)/) != -1) {
    initQrCode();
    displayWarrantyButtons();
    showAlertMessage();
} else if (currentUrl.includes('/account?view=register_warranty')) {
    prefillWarrantyInfo();
} else if (currentUrl.includes('/account?view=ext_warranty')) {
    externalWarrantyClickEvents();
} else if (currentUrl.includes('/account?view=warranty')) {
    formatWarrantyPage();
    displayRepairPopup();
    showAlertMessage();
} else if (currentUrl.includes('/account?view=repair_request')) {
    fillRepairDetails();
} else if (currentUrl.includes('/account?view=settings')) {
    initSettingsModals();
} else if (currentUrl.includes('repair-2')) {
    redirectEvent();
} else if (currentUrl.includes('/collections')) {
    swatchSlider();
}

customproductbuilder();
menuHamberger();
lineitemchange();
customVideo();
// textInlineWithIcons();